<template>
  <div class="orders">
    <el-table v-loading="loading" :data="list" border>
      <el-table-column prop="order_no" label="订单号" min-width="180" show-overflow-tooltip />
      <el-table-column prop="activity_title" label="活动" min-width="160" show-overflow-tooltip />
      <el-table-column prop="quantity" label="人数" width="70" />
      <el-table-column prop="pay_amount" label="金额" width="90" />
      <el-table-column label="签到" width="100">
        <template #default="scope">{{ scope.row.checkin_count }}/{{ scope.row.quantity }}</template>
      </el-table-column>
      <el-table-column label="支付状态" width="90">
        <template #default="scope">{{ payText(scope.row.pay_status) }}</template>
      </el-table-column>
      <el-table-column label="退款状态" width="90">
        <template #default="scope">{{ refundText(scope.row.refund_status) }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="180">
        <template #default="scope">
          <el-button link type="warning" :disabled="scope.row.pay_status !== 1 || scope.row.refund_status === 1" @click="openRefund(scope.row)">退款</el-button>
          <el-button link type="primary" :disabled="scope.row.pay_status !== 1 || scope.row.invoice_status !== 0" @click="openInvoice(scope.row)">发票</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pager"
      background
      layout="total, prev, pager, next"
      :total="total"
      :page-size="pageSize"
      v-model:current-page="page"
      @current-change="load"
    />

    <el-dialog v-model="refundVisible" title="申请退款" width="480px">
      <el-input v-model="refundReason" type="textarea" :rows="3" placeholder="请填写退款原因" />
      <template #footer>
        <el-button @click="refundVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRefund">提交</el-button>
      </template>
    </el-dialog>

    <el-dialog
      v-model="invoiceVisible"
      title="申请发票"
      width="720px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="activity-invoice-dialog"
    >
      <el-form ref="invoiceFormRef" :model="invoice" :rules="invoiceRules" label-width="110px">
        <el-form-item label="活动订单">
          <div class="order-summary" v-if="invoice.order_no">
            <div class="summary-row"><span>订单号</span><strong>{{ invoice.order_no }}</strong></div>
            <div class="summary-row"><span>活动名称</span><strong>{{ invoice.activity_title || '-' }}</strong></div>
            <div class="summary-row"><span>支付金额</span><strong>¥{{ invoice.pay_amount || '0.00' }}</strong></div>
          </div>
        </el-form-item>
        <el-form-item label="抬头类型" prop="title_type">
          <el-radio-group v-model="invoice.title_type" @change="handleTitleTypeChange">
            <el-radio :label="1">个人</el-radio>
            <el-radio :label="2">企业</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="常用抬头">
          <el-select
            v-model="invoice.invoice_title_id"
            placeholder="选择系统内发票抬头，或直接填写新的抬头"
            clearable
            filterable
            class="full"
            @change="selectInvoiceTitle"
          >
            <el-option
              v-for="item in titleRows"
              :key="item.id"
              :label="titleOptionLabel(item)"
              :value="item.id"
            />
          </el-select>
          <el-button class="reuse-btn" type="primary" link @click="loadReusableTitle">使用默认/最近抬头</el-button>
        </el-form-item>
        <el-form-item label="发票抬头" prop="invoice_title">
          <el-input v-model="invoice.invoice_title" placeholder="个人姓名或企业名称" />
        </el-form-item>
        <template v-if="Number(invoice.title_type) === 2">
          <el-form-item label="纳税人识别号" prop="tax_no">
            <el-input v-model="invoice.tax_no" placeholder="统一社会信用代码/税号" />
          </el-form-item>
          <el-form-item label="企业地址">
            <el-input v-model="invoice.company_address" placeholder="选填" />
          </el-form-item>
          <el-form-item label="企业电话">
            <el-input v-model="invoice.company_phone" placeholder="选填" />
          </el-form-item>
          <el-form-item label="开户银行">
            <el-input v-model="invoice.bank_name" placeholder="选填" />
          </el-form-item>
          <el-form-item label="银行账号">
            <el-input v-model="invoice.bank_account" placeholder="选填" />
          </el-form-item>
        </template>
        <el-form-item label="收票联系人" prop="contact_name">
          <el-input v-model="invoice.contact_name" />
        </el-form-item>
        <el-form-item label="手机号" prop="contact_phone">
          <el-input v-model="invoice.contact_phone" />
        </el-form-item>
        <el-form-item label="邮箱" prop="contact_email">
          <el-input v-model="invoice.contact_email" placeholder="用于接收电子发票" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="invoice.remark" type="textarea" :rows="3" placeholder="选填" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="invoiceVisible = false">取消</el-button>
        <el-button type="primary" :loading="invoiceSubmitting" @click="submitInvoice">提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import activity from '@/api/activity'
import invoiceApi from '@/api/invoice'

export default {
  name: 'activityMyOrders',
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      refundVisible: false,
      refundRow: {},
      refundReason: '',
      invoiceVisible: false,
      invoiceSubmitting: false,
      titleRows: [],
      invoice: this.defaultInvoice(),
      invoiceRules: {
        title_type: [{ required: true, message: '请选择抬头类型', trigger: 'change' }],
        invoice_title: [{ required: true, message: '请填写发票抬头', trigger: 'blur' }],
        tax_no: [{ required: true, message: '请填写纳税人识别号', trigger: 'blur' }],
        contact_name: [{ required: true, message: '请填写收票联系人', trigger: 'blur' }],
        contact_phone: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
        contact_email: [
          { required: true, message: '请填写邮箱', trigger: 'blur' },
          { type: 'email', message: '请填写正确的邮箱', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    defaultInvoice() {
      return {
        order_id: null,
        order_no: '',
        activity_title: '',
        pay_amount: '',
        invoice_title_id: null,
        title_type: 1,
        invoice_title: '',
        tax_no: '',
        company_address: '',
        company_phone: '',
        bank_name: '',
        bank_account: '',
        contact_name: '',
        contact_phone: '',
        contact_email: '',
        remark: ''
      }
    },
    payText(status) {
      return ({ 0: '待支付', 1: '已支付', 2: '失败', 3: '关闭', 4: '已退款' })[status] || '-'
    },
    refundText(status) {
      return ({ 0: '未申请', 1: '待审核', 2: '已退款', 3: '已驳回' })[status] || '-'
    },
    async load() {
      this.loading = true
      try {
        const res = await activity.myOrders({ page: this.page, limit: this.pageSize })
        if (res) {
          this.list = res.data.data || []
          this.total = res.data.total || 0
        }
      } finally {
        this.loading = false
      }
    },
    openRefund(row) {
      this.refundRow = { ...row }
      this.refundReason = ''
      this.refundVisible = true
    },
    async submitRefund() {
      const res = await activity.applyRefund({ order_id: this.refundRow.id, reason: this.refundReason })
      if (res) {
        this.$message.success(res.msg)
        this.refundVisible = false
        this.load()
      }
    },
    async loadTitleList() {
      const res = await invoiceApi.titleList({ title_type: this.invoice.title_type })
      this.titleRows = res && res.data ? res.data : []
    },
    async loadReusableTitle() {
      const res = await invoiceApi.reusableTitle({ title_type: this.invoice.title_type })
      if (res && res.data) {
        this.fillTitle(res.data)
      }
    },
    async openInvoice(row) {
      this.invoice = {
        ...this.defaultInvoice(),
        order_id: row.id,
        order_no: row.order_no,
        activity_title: row.activity_title,
        pay_amount: row.pay_amount,
        contact_name: row.contact_name || '',
        contact_phone: row.contact_mobile || '',
        contact_email: ''
      }
      this.invoiceVisible = true
      await this.loadTitleList()
      await this.loadReusableTitle()
      this.$nextTick(() => {
        this.$refs.invoiceFormRef && this.$refs.invoiceFormRef.clearValidate()
      })
    },
    async handleTitleTypeChange() {
      const orderInfo = {
        order_id: this.invoice.order_id,
        order_no: this.invoice.order_no,
        activity_title: this.invoice.activity_title,
        pay_amount: this.invoice.pay_amount
      }
      this.invoice = {
        ...this.defaultInvoice(),
        ...orderInfo,
        title_type: this.invoice.title_type
      }
      await this.loadTitleList()
      await this.loadReusableTitle()
    },
    selectInvoiceTitle(id) {
      const row = this.titleRows.find(item => item.id === id)
      if (row) {
        this.fillTitle(row)
      }
    },
    fillTitle(data) {
      Object.assign(this.invoice, {
        invoice_title_id: data.id || null,
        title_type: data.title_type || this.invoice.title_type,
        invoice_title: data.invoice_title || '',
        tax_no: data.tax_no || '',
        company_address: data.company_address || '',
        company_phone: data.company_phone || '',
        bank_name: data.bank_name || '',
        bank_account: data.bank_account || '',
        contact_name: data.contact_name || this.invoice.contact_name,
        contact_phone: data.contact_phone || this.invoice.contact_phone,
        contact_email: data.contact_email || this.invoice.contact_email
      })
    },
    titleOptionLabel(item) {
      const suffix = item.title_type === 2 && item.tax_no ? ` / ${item.tax_no}` : ''
      return `${item.invoice_title}${suffix}${item.is_default ? ' / 默认' : ''}`
    },
    submitInvoice() {
      this.$refs.invoiceFormRef.validate(async valid => {
        if (!valid) return
        this.invoiceSubmitting = true
        try {
          const res = await activity.invoiceSubmit({
            order_id: this.invoice.order_id,
            invoice_title_id: this.invoice.invoice_title_id,
            title_type: this.invoice.title_type,
            invoice_title: this.invoice.invoice_title,
            tax_no: this.invoice.tax_no,
            company_address: this.invoice.company_address,
            company_phone: this.invoice.company_phone,
            bank_name: this.invoice.bank_name,
            bank_account: this.invoice.bank_account,
            contact_name: this.invoice.contact_name,
            contact_phone: this.invoice.contact_phone,
            contact_email: this.invoice.contact_email,
            remark: this.invoice.remark
          })
          if (res) {
            this.$message.success(res.msg || '提交成功')
            this.invoiceVisible = false
            await this.load()
          }
        } finally {
          this.invoiceSubmitting = false
        }
      })
    }
  }
}
</script>

<style scoped>
.orders {
  padding: 30px;
}

.pager {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.full {
  width: 100%;
}

.reuse-btn {
  margin-left: 12px;
}

.order-summary {
  width: 100%;
  padding: 12px 16px;
  background: #f8f9fb;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  color: #606266;
  line-height: 1.8;
}

.summary-row strong {
  color: #303133;
  font-weight: 600;
}

@media (max-width: 768px) {
  .orders {
    padding: 16px 12px;
  }

  .reuse-btn {
    display: block;
    margin-left: 0;
    margin-top: 6px;
    width: fit-content;
  }

  .summary-row {
    flex-direction: column;
    gap: 4px;
  }
}
</style>

<style>
.activity-invoice-dialog {
  max-width: calc(100vw - 32px);
}

.activity-invoice-dialog .el-dialog__body {
  max-height: calc(92vh - 126px);
  overflow-y: auto;
  padding-right: 24px;
}

.activity-invoice-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding-top: 16px;
}

.activity-invoice-dialog .el-select,
.activity-invoice-dialog .el-input,
.activity-invoice-dialog .el-textarea {
  width: 100%;
}

@media (max-width: 768px) {
  .activity-invoice-dialog {
    max-width: 100vw;
  }

  .activity-invoice-dialog .el-dialog__header {
    padding: 16px 16px 10px;
  }

  .activity-invoice-dialog .el-dialog__body {
    max-height: calc(100vh - 122px);
    padding: 12px 16px;
  }

  .activity-invoice-dialog .el-dialog__footer {
    padding: 12px 16px 16px;
  }
}
</style>
